module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_WATER_LEVEL.f5e3b581.png";